<template>
    <div class="container-fluid">
        <!-- Top Stats Row -->
        <div class="row g-3 mt-1 mb-3 align-items-stretch">
            <div class="col-12 col-sm-6 col-xl-2">
                <mini-statistics-card 
                    title="İmzalanmayan müqavilələr" 
                    value="12"
                    badge="Diqqət"
                    accent="amber"
                    iconClass="bi bi-file-earmark-excel" />
            </div>
            <div class="col-12 col-sm-6 col-xl-2">
                <mini-statistics-card 
                    title="İmza gözləyən müqavilələr" 
                    value="4"
                    badge="Gözləmədə"
                    accent="indigo"
                    iconClass="bi bi-pen" />
            </div>
            <div class="col-12 col-sm-6 col-xl-2">
                <mini-statistics-card 
                    title="Sorğular" 
                    value="36"
                    badge="Aktiv"
                    accent="emerald"
                    iconClass="bi bi-chat-square-text" />
            </div>
            <div class="col-12 col-sm-6 col-xl-2">
                <mini-statistics-card 
                    title="Təsdiq gözləyən ərizələr" 
                    value="3"
                    badge="İcrada"
                    accent="cyan"
                    iconClass="bi bi-clock-history" />
            </div>
            <div class="col-12 col-xl-4">
                <mini-rate-card />
            </div>
        </div>

        <!-- Middle Row: Requests Table & Mixed Chart -->
        <div class="row g-3 mb-3 align-items-stretch">
            <div class="col-12 col-xl-6">
                <div class="card h-100">
                    <div class="py-2 px-3 card-header d-flex justify-content-between align-items-center">
                        <h6 class="mb-0 font-weight-bolder">Sorğular</h6>
                        <button type="button" @click="GoToUnderwriting()" class="btn bg-gradient-info mb-0 py-1 px-3 d-inline-flex align-items-center gap-2" style="font-size: 12px; min-height: 30px;">
                            <i class="bi bi-inbox-fill text-white"></i>
                            <span class="btn-text text-white">Sorğulara keçid</span>
                            <i class="bi bi-arrow-right-short text-white" style="font-size: 15px; margin-left: -3px;"></i>
                        </button>
                    </div>
                    <div class="p-3 card-body">
                        <div class="table-responsive">
                            <el-table border :data="this.dataReq" class="el-table-css" height="260"
                                style="width: 100%">
                                <el-table-column label="Status" width="130">
                                    <template #default="{ row }">
                                        <el-button size="small" style="width:100%; justify-content:center;"
                                            :class="{ 'no-icon-space': !(row.statusId === 1 || row.statusId === 2 || row.statusId === 3 || row.statusId === 4) }"
                                            :type="row.statusId === 3 ? 'danger' : row.statusId === 2 ? 'success' : row.statusId === 1 ? 'info' : row.statusId === 4 ? 'primary' : ''"
                                            :icon="row.statusId === 3 ? CloseBold : row.statusId === 2 ? Check : undefined"
                                            :loading="row.statusId === 1 || row.statusId === 4"
                                            :loading-icon="row.statusId === 1 || row.statusId === 4 ? Eleme : undefined">
                                            {{ row.quotaStatusName }}
                                        </el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="reqType" label="Sorğu növü" width="160" />
                                <el-table-column label="Təklif nömrəsi" width="130">
                                    <template #default="scope">
                                        <a class="number-link" style="color: #007bff; cursor: pointer;"
                                            @click="GoToQuota(scope.row.quotaId)">{{
                                                scope.row.quotaFullNumber }}</a>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="insured.name" label="Sığortalı" />
                                <el-table-column width="55" align="center" class-name="dash-action-col">
                                    <template #default="scope">
                                        <el-popover placement="left-start" :width="270" trigger="hover">
                                            <template #reference>
                                                <button type="button" class="dash-info-btn"><i class="bi bi-info-circle"></i></button>
                                            </template>
                                            <template #default>
                                                <div class="dash-popover-content">
                                                    <div class="dash-popover-title">
                                                        <i class="bi bi-info-circle-fill text-info"></i>
                                                        <span>Ətraflı Məlumat</span>
                                                    </div>
                                                    <div class="dash-popover-row">
                                                        <span class="dash-popover-label"><i class="bi bi-calendar-plus"></i> Daxil olunub:</span>
                                                        <span class="dash-popover-value">{{ scope.row.created }}</span>
                                                    </div>
                                                    <div class="dash-popover-row">
                                                        <span class="dash-popover-label"><i class="bi bi-calendar-check"></i> Düzəliş olunub:</span>
                                                        <span class="dash-popover-value">{{ scope.row.updated }}</span>
                                                    </div>
                                                    <div v-if="scope.row.insuredPerson" class="dash-popover-row">
                                                        <span class="dash-popover-label"><i class="bi bi-person"></i> Şəxs:</span>
                                                        <span class="dash-popover-value">{{ scope.row.insuredPerson.name }}</span>
                                                    </div>
                                                </div>
                                            </template>
                                        </el-popover>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-xl-6">
                <div class="card h-100">
                    <div class="py-2 px-3 card-header d-flex justify-content-between align-items-center">
                        <h6 class="mb-0 font-weight-bolder">Statistika</h6>
                        <button type="button" @click="GoToPolicy()" class="btn bg-gradient-info mb-0 py-1 px-3 d-inline-flex align-items-center gap-2" style="font-size: 12px; min-height: 30px;">
                            <i class="bi bi-file-earmark-text-fill text-white"></i>
                            <span class="btn-text text-white">Müqavilələrə keçid</span>
                            <i class="bi bi-arrow-right-short text-white" style="font-size: 15px; margin-left: -3px;"></i>
                        </button>
                    </div>
                    <div class="p-3 card-body">
                        <div style="height: 260px;">
                            <mixed-chart height="260" :chart="{
                                labels: [
                                    'Apr',
                                    'May',
                                    'Jun',
                                    'Jul',
                                    'Aug',
                                    'Sep',
                                    'Oct',
                                    'Nov',
                                    'Dec',
                                ],
                                datasets: [
                                    {
                                        label: 'Müqavilə',
                                        data: [10, 15, 20, 5, 18, 12, 25, 7, 22],
                                    }, 
                                    {
                                        label: 'Əlavə',
                                        data: [5, 9, 14, 11, 22, 6, 19, 25, 13],
                                    },
                                ]
                            }" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bottom Row: Timeline Lists -->
        <div class="row g-3 mb-4 align-items-stretch">
            <div class="col-12 col-xl-6">
                <timeline-list 
                    title="Tamamlanmamış tapşırıqlar" 
                    subtitle="Təcili və diqqət tələb edən işlər"
                    accent="danger"
                    badge="8 tapşırıq">
                    <timeline-item 
                        color="danger" 
                        icon="bi bi-exclamation-triangle-fill"
                        tag="Görüş"
                        title="Müştəri görüşü – Rauf Əliyev (saziş müzakirəsi)" 
                        date-time="09 SEN 09:30" />
                    <timeline-item 
                        color="danger" 
                        icon="bi bi-exclamation-triangle-fill"
                        tag="Hesabat"
                        title="Hesabat hazırlanması – #HR-1023" 
                        date-time="09 SEN 15:00" />
                    <timeline-item 
                        color="danger" 
                        icon="bi bi-exclamation-triangle-fill"
                        tag="450 AZN"
                        title="Son tarix – Ödəniş gözlənilir (450 AZN)" 
                        date-time="10 SEN 10:30" />
                    <timeline-item 
                        color="danger" 
                        icon="bi bi-exclamation-triangle-fill"
                        tag="Zəng"
                        title="Müştəri zəngi – Leyla Hüseynova" 
                        date-time="10 SEN 13:15" />
                    <timeline-item 
                        color="danger" 
                        icon="bi bi-exclamation-triangle-fill"
                        tag="Təlim"
                        title="Təlim sessiyası – Satış komandası" 
                        date-time="11 SEN 09:00" />
                    <timeline-item 
                        color="danger" 
                        icon="bi bi-exclamation-triangle-fill"
                        tag="Təklif"
                        title="Yeni təklif göndərilməlidir – #QF-778" 
                        date-time="11 SEN 14:45" />
                    <timeline-item 
                        color="danger" 
                        icon="bi bi-exclamation-triangle-fill"
                        tag="Araşdırma"
                        title="Şikayət araşdırılmalıdır – Müştəri #LI-3055" 
                        date-time="12 SEN 11:00" />
                    <timeline-item 
                        color="danger" 
                        icon="bi bi-exclamation-triangle-fill"
                        tag="Məhsul"
                        title="Yeni məhsul təqdimatı – Premium Health Plan" 
                        date-time="13 SEN 15:30" />
                </timeline-list>
            </div>
            <div class="col-12 col-xl-6">
                <timeline-list 
                    title="Gözləyən tapşırıqlar" 
                    subtitle="Planlaşdırılmış növbəti işlər"
                    accent="warning"
                    badge="8 tapşırıq">
                    <timeline-item 
                        color="warning" 
                        icon="bi bi-telephone-fill"
                        tag="Zəng"
                        title="Müştəriyə zəng – Elçin Quliyev (təklif müzakirəsi)" 
                        date-time="09 SEN 11:00" />
                    <timeline-item 
                        color="cyan" 
                        icon="bi bi-file-earmark-medical-fill"
                        tag="Layihə"
                        title="Polis layihəsi hazırlanması – #LI-2044" 
                        date-time="09 SEN 16:30" />
                    <timeline-item 
                        color="danger" 
                        icon="bi bi-credit-card-2-front-fill"
                        tag="320 AZN"
                        title="Son tarix – Ödəniş gözlənilir (320 AZN)" 
                        date-time="10 SEN 12:00" />
                    <timeline-item 
                        color="emerald" 
                        icon="bi bi-heart-pulse-fill"
                        tag="Müayinə"
                        title="Sağlamlıq müayinəsi təyin edilməlidir – Nigar Məlikova" 
                        date-time="10 SEN 14:00" />
                    <timeline-item 
                        color="indigo" 
                        icon="bi bi-person-video3"
                        tag="Təlim"
                        title="Təlim təqdimatı – Agentlər üçün" 
                        date-time="11 SEN 10:00" />
                    <timeline-item 
                        color="warning" 
                        icon="bi bi-envelope-check-fill"
                        tag="Təklif"
                        title="Müştəriyə təklif göndərilməlidir – #QF-552" 
                        date-time="11 SEN 16:30" />
                    <timeline-item 
                        color="danger" 
                        icon="bi bi-exclamation-octagon-fill"
                        tag="Şikayət"
                        title="Şikayətə baxılmalıdır – Polis #LI-1988" 
                        date-time="12 SEN 09:00" />
                    <timeline-item 
                        color="purple" 
                        icon="bi bi-award-fill"
                        tag="Təqdimat"
                        title="Yeni məhsul təqdimatı – Life Premium Plan" 
                        date-time="13 SEN 11:00" />
                </timeline-list>
            </div>
        </div>
    </div>
</template>

<script>
import MiniStatisticsCard from "./Components/MiniStatisticsCard.vue";
import MiniRateCard from "./Components/MiniRateCard.vue";
import MixedChart from "./Components/MixedChart.vue";
import { Check, CloseBold, InfoFilled, Eleme } from "@element-plus/icons-vue";
import TimelineList from "./Components/TimelineList.vue";
import TimelineItem from "./Components/TimelineItem.vue";

export default {
    components: {
        MiniRateCard,
        TimelineList,
        TimelineItem,
        MiniStatisticsCard,
        MixedChart,
    },
    data() {
        return {
            Check, 
            CloseBold, 
            InfoFilled,
            Eleme,
            dataPolicy: [
                {
                    medicalPolicy: {
                        issued: true,
                        signStatus: 'İmzalanıb',
                        policyId: 1001,
                        policyFullNumber: "SS-2025-000123",
                        policyStatusName: "Aktiv",
                        policyDateStr: "16.08.2025",
                        insuredPerson: { name: "Elvin Əliyev" },
                        insured: { name: "Əli Məmmədov" },
                        startDateStr: "01.01.2025",
                        endDateStr: "31.12.2025",
                        cancelDateStr: "",
                        payType: "Aylıq",
                        currency: "AZN",
                        cancelTypeName: ""
                    }
                },
                {
                    medicalPolicy: {
                        issued: false,
                        policyId: 1002,
                        signStatus: 'Kuratorun imzası gözlənilir',
                        policyFullNumber: "SS-2025-000124",
                        policyStatusName: "Dayandırılıb",
                        policyDateStr: "10.07.2025",
                        insured: { name: "Leyla Quliyeva" },
                        startDateStr: "01.02.2025",
                        insuredPerson: { name: "Leyla Məmmədova" },
                        endDateStr: "01.08.2025",
                        payType: "Aylıq",
                        currency: "AZN",
                        cancelDateStr: "05.07.2025",
                        cancelTypeName: "Müştəri tələbi ilə"
                    }
                },
                {
                    medicalPolicy: {
                        issued: true,
                        policyId: 1003,
                        signStatus: 'İmzalanıb',
                        policyFullNumber: "SS-2025-000125",
                        policyStatusName: "Aktiv",
                        policyDateStr: "05.06.2025",
                        insured: { name: "Rauf Həsənov" },
                        startDateStr: "15.06.2025",
                        endDateStr: "15.06.2026",
                        payType: "Birdəfəlik",
                        insuredPerson: { name: "Elvin Bayramov" },
                        currency: "USD",
                        cancelDateStr: "",
                        cancelTypeName: ""
                    }
                },
                {
                    medicalPolicy: {
                        issued: true,
                        policyId: 1004,
                        signStatus: 'İmzalanıb',
                        policyFullNumber: "SS-2025-000126",
                        policyStatusName: "Aktiv",
                        policyDateStr: "20.08.2025",
                        insuredPerson: { name: "Aytac Əliyeva" },
                        insured: { name: "Fərid Məmmədov" },
                        startDateStr: "01.09.2025",
                        endDateStr: "31.08.2026",
                        payType: "Aylıq",
                        currency: "AZN",
                        cancelDateStr: "",
                        cancelTypeName: ""
                    }
                },
                {
                    medicalPolicy: {
                        issued: false,
                        policyId: 1005,
                        signStatus: 'Kuratorun imzası gözlənilir',
                        policyFullNumber: "SS-2025-000127",
                        policyStatusName: "Dayandırılıb",
                        policyDateStr: "15.07.2025",
                        insured: { name: "Səmra Quliyeva" },
                        startDateStr: "01.08.2025",
                        insuredPerson: { name: "Səmra Məmmədova" },
                        endDateStr: "01.02.2026",
                        payType: "Aylıq",
                        currency: "USD",
                        cancelDateStr: "10.07.2025",
                        cancelTypeName: "Müştəri tələbi ilə"
                    }
                },
                {
                    medicalPolicy: {
                        issued: true,
                        policyId: 1006,
                        signStatus: 'İmzalanıb',
                        policyFullNumber: "SS-2025-000128",
                        policyStatusName: "Aktiv",
                        policyDateStr: "01.09.2025",
                        insured: { name: "Rəşad Həsənov" },
                        startDateStr: "05.09.2025",
                        endDateStr: "05.09.2026",
                        payType: "Birdəfəlik",
                        insuredPerson: { name: "Nərmin Bayramova" },
                        currency: "AZN",
                        cancelDateStr: "",
                        cancelTypeName: ""
                    }
                }
            ],
            dataReq: [
                {
                    quotaId: 1,
                    reqType: "Ərizə təsdiqləmə",
                    quotaFullNumber: "Q-2025-001",
                    statusId: 2,
                    quotaStatusName: "Təsdiq",
                    quotaDateStr: "16.08.2025",
                    insured: { name: "ABC Şirkəti" },
                    insuredPerson: { name: "Elvin Əliyev" },
                    insuredCount: 25,
                    payType: "Aylıq",
                    currency: "AZN",
                    period: 36,
                    created: "16.08.2025 10:00",
                    updated: "16.08.2025 12:30"
                },
                {
                    quotaId: 2,
                    reqType: "Ərizə təsdiqləmə",
                    quotaFullNumber: "Q-2025-002",
                    statusId: 1,
                    quotaStatusName: "Yeni",
                    quotaDateStr: "15.08.2025",
                    insured: { name: "XYZ MMC" },
                    insuredPerson: { name: "Murad Həsənov" },
                    insuredCount: 15,
                    period: 48,
                    payType: "Aylıq",
                    currency: "AZN",
                    created: "15.08.2025 09:20",
                    updated: "15.08.2025 11:45"
                },
                {
                    quotaId: 3,
                    reqType: "Müqavilənin bərpası",
                    quotaFullNumber: "Q-2025-003",
                    statusId: 3,
                    quotaStatusName: "İmtina",
                    quotaDateStr: "14.08.2025",
                    insured: { name: "Delta Ltd." },
                    insuredPerson: { name: "Leyla Məmmədova" },
                    insuredCount: 40,
                    payType: "Aylıq",
                    currency: "AZN",
                    period: 48,
                    created: "14.08.2025 08:10",
                    updated: "14.08.2025 10:00"
                },
                {
                    quotaId: 4,
                    quotaFullNumber: "Q-2025-004",
                    reqType: "Sığorta haqqının dəyişdirilməsi",
                    statusId: 4,
                    quotaStatusName: "İcrahatda",
                    quotaDateStr: "13.08.2025",
                    insured: { name: "Gamma Corp." },
                    insuredPerson: { name: "Elvin Bayramov" },
                    insuredCount: 30,
                    period: 36,
                    payType: "Birdəfəlik",
                    currency: "USD",
                    created: "13.08.2025 14:15",
                    updated: "13.08.2025 16:50"
                },
                {
                    quotaId: 5,
                    quotaFullNumber: "Q-2025-005",
                    reqType: "Konvertasiya",
                    statusId: 1,
                    quotaStatusName: "Yeni",
                    quotaDateStr: "12.08.2025",
                    insured: { name: "Beta Holding" },
                    insuredPerson: { name: "Rıza Xanlı" },
                    insuredCount: 50,
                    payType: "Aylıq",
                    currency: "EUR",
                    period: 36,
                    created: "12.08.2025 11:30",
                    updated: "12.08.2025 13:00"
                },
                {
                    quotaId: 6,
                    quotaFullNumber: "Q-2025-006",
                    reqType: "Ərizə təsdiqləmə",
                    statusId: 1,
                    quotaStatusName: "Yeni",
                    quotaDateStr: "11.08.2025",
                    insured: { name: "Omega Bank" },
                    insuredPerson: { name: "Samir Quliyev" },
                    insuredCount: 20,
                    payType: "Aylıq",
                    currency: "AZN",
                    period: 24,
                    created: "11.08.2025 10:40",
                    updated: "11.08.2025 12:10"
                },
                {
                    quotaId: 7,
                    quotaFullNumber: "Q-2025-007",
                    reqType: "Müqavilənin bərpası",
                    statusId: 2,
                    quotaStatusName: "Təsdiq",
                    quotaDateStr: "10.08.2025",
                    insured: { name: "Sigma LLC" },
                    insuredPerson: { name: "Aysel Məlikova" },
                    insuredCount: 60,
                    payType: "Birdəfəlik",
                    currency: "USD",
                    period: 12,
                    created: "10.08.2025 09:15",
                    updated: "10.08.2025 11:25"
                },
                {
                    quotaId: 8,
                    quotaFullNumber: "Q-2025-008",
                    reqType: "Sığorta haqqının dəyişdirilməsi",
                    statusId: 3,
                    quotaStatusName: "İmtina",
                    quotaDateStr: "09.08.2025",
                    insured: { name: "Orion Group" },
                    insuredPerson: { name: "Nigar Qasımova" },
                    insuredCount: 35,
                    payType: "Aylıq",
                    currency: "AZN",
                    period: 60,
                    created: "09.08.2025 08:30",
                    updated: "09.08.2025 10:00"
                },
                {
                    quotaId: 9,
                    quotaFullNumber: "Q-2025-009",
                    reqType: "Konvertasiya",
                    statusId: 4,
                    quotaStatusName: "İcrahatda",
                    quotaDateStr: "08.08.2025",
                    insured: { name: "NovaTech" },
                    insuredPerson: { name: "Kamal Rəhimli" },
                    insuredCount: 45,
                    payType: "Aylıq",
                    currency: "EUR",
                    period: 36,
                    created: "08.08.2025 13:50",
                    updated: "08.08.2025 15:20"
                },
                {
                    quotaId: 10,
                    quotaFullNumber: "Q-2025-010",
                    reqType: "Ərizə təsdiqləmə",
                    statusId: 2,
                    quotaStatusName: "Təsdiq",
                    quotaDateStr: "07.08.2025",
                    insured: { name: "Atlas MMC" },
                    insuredPerson: { name: "Eldar Hüseynov" },
                    insuredCount: 28,
                    payType: "Birdəfəlik",
                    currency: "AZN",
                    period: 18,
                    created: "07.08.2025 09:00",
                    updated: "07.08.2025 10:30"
                }
            ]
        }
    },
    methods: {
        GoToPolicy() {
            window.open(window.location.origin + '/documents/policies', "_blank");
        },
        GoToUnderwriting() {
            window.open(window.location.origin + '/documents/requests', "_blank");
        },
        GoToQuota(value) {
            window.open(window.location.origin + '/underwriting/quota/' + value, "_blank");
        }
    }
}
</script>

<style scoped lang="scss">
.dash-info-btn {
  width: 26px;
  height: 26px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid var(--app-border, rgba(255, 255, 255, 0.1));
  color: var(--app-text, #94a3b8);
  font-size: 13.5px;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(56, 189, 248, 0.18);
    color: #38bdf8;
    border-color: rgba(56, 189, 248, 0.35);
    transform: scale(1.1);
  }
}

.dash-popover-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px;
}

.dash-popover-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--app-heading, #f1f5f9);
  border-bottom: 1px solid var(--app-border, rgba(255, 255, 255, 0.08));
  padding-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.dash-popover-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.dash-popover-label {
  color: var(--app-text, #94a3b8);
  display: flex;
  align-items: center;
  gap: 5px;
}

.dash-popover-value {
  font-weight: 600;
  color: var(--app-heading, #f1f5f9);
}

/* Light mode adjustments */
html[data-theme="light"] {
  .dash-info-btn {
    background: #f1f5f9;
    border-color: #e2e8f0;
    color: #64748b;

    &:hover {
      background: #e0f2fe;
      color: #0284c7;
      border-color: #7dd3fc;
    }
  }

  .dash-popover-title,
  .dash-popover-value {
    color: #0f172a;
  }
}

:deep(.dash-action-col) {
  padding: 0 !important;
}

:deep(.dash-action-col .cell) {
  padding: 0 !important;
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
}
</style>